import { render, staticRenderFns } from "./PrintPosFacturaSolAmbientalModular.vue?vue&type=template&id=ba438d30"
import script from "./PrintPosFacturaSolAmbientalModular.vue?vue&type=script&lang=js"
export * from "./PrintPosFacturaSolAmbientalModular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports